/**
 * WHATSAPP SESSION API — Wrapper REST Liferay allineato a
 * WhatsAppMessagesResourceImpl.getWhatsAppSessions.
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET /whatsapp-sessions/{groupId}/{personId} -> Page<WhatsAppSession>
 *   - GET /whatsapp-conversations/{groupId}       -> Page<WhatsAppConversation>
 *
 * Sola lettura: le sessioni nascono lato backend (attach-or-create). Si leggono
 * per contatto e portano i messaggi annidati.
 */

import type { Page } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import {
  whatsAppSessionFromDto,
  type WhatsAppSessionDto,
} from './whatsAppSessionMappers';
import type { WhatsAppConversation, WhatsAppSession } from './whatsAppSessionTypes';

const COLLECTION = '/whatsapp-sessions';
const SINGLE = '/whatsapp-session';

export const whatsAppSessionApi = {
  getByPerson: (
    groupId: number,
    personId: number,
  ): Promise<WhatsAppSession[]> =>
    httpClient
      .get<Page<WhatsAppSessionDto>>(`${COLLECTION}/${groupId}/${personId}`)
      .then((r) => r.data.items.map(whatsAppSessionFromDto)),

  // Le conversazioni della pagina WhatsApp: un contatto per riga, dal più recente.
  getConversations: (groupId: number): Promise<WhatsAppConversation[]> =>
    httpClient
      .get<Page<WhatsAppConversation>>(`/whatsapp-conversations/${groupId}`)
      .then((r) => r.data.items),

  // Elimina la sessione e, a cascata, i suoi messaggi (lato backend).
  remove: (whatsAppSessionId: number): Promise<void> =>
    httpClient.delete(`${SINGLE}/${whatsAppSessionId}`).then(() => undefined),
};
